<template>
  <div class="eth-liquefy">
    <div class="liquefy-header">
      <div class="arrow-icon" @click="back">
        <img src="../assets/arrow-left.png" />
      </div>
      <div class="title">
        Liquify
      </div>
    </div>
    <div class="liquefy-content">
      <div class="liquefy-desc">
        StaFi provide liquidity for validator according to the performance on node operation, validator can liquify deposited ETH by receiving FIS as return.
      </div>

      <div class="liquefy-item">
        <div class="liquefy-item-title">
          Check contract address
        </div>
        <div class="liquefy-item-input">
          <select v-model="selectedAddress">
            <template 
              v-for="(item, index) in addressItems" >
              <option v-if="item == selectedAddress" :key="index" :value="item" selected="selected">{{ item }}</option>
              <option v-else :key="index" :value="item">{{ item }}</option>
            </template>
          </select>
        </div>

        <div class="liquefy-item-title">
          Liquidable ETH
        </div>
        <div class="liquefy-item-input">
          <input type="text" v-model="liquidableEthAmountShow" readOnly="true" />
        </div>

        <div class="liquefy-item-title">
          Received FIS
        </div>
        <div class="liquefy-item-input">
          <input type="text" v-model="receivedFisAmountShow" readOnly="true" />
        </div>

      </div>

      <div class="liquefy-btn" :class="{'btn-active': liquefyBtnActiveStatus == 1}">
        Liquify
      </div>

    </div>
  </div>
</template>

<script>
import Web3Util from '../util/web3Util.js';
import LocalStorage from '../util/localStorage.js';

export default {
  name: 'ethliquify',
  data() {
    return {
      selectedAddress: '',
      addressItems: [],
      liquidableEthAmountShow: '0 ETH',
      receivedFisAmountShow: '0 FIS',
      liquefyBtnActiveStatus: 0
    }
  },
  created() {
    if (ethereum.selectedAddress) {
      let address = ethereum.selectedAddress;
      let web3 = Web3Util.getWeb3();
      let contract = new web3.eth.Contract(Web3Util.getStafiStakingPoolManagerAbi(), Web3Util.getStafiStakingPoolManagerAddress(), {
        from: address
      });

      contract.methods.getNodeStakingPoolCount(address).call().then(poolCount => {
        if (poolCount > 0) {

          for (let index = 0; index < poolCount; index++) {
            contract.methods.getNodeStakingPoolAt(address, index).call().then(poolAddress => {

              let pubKey = LocalStorage.getPoolPubKey(poolAddress);
              if (pubKey) {
                this.addressItems.push(poolAddress);
                if (!this.selectedAddress) {
                  this.selectedAddress = poolAddress;
                }
              } else {
                contract.methods.getStakingPoolPubkey(poolAddress).call().then(pubkey => {
                  if (pubkey) {
                    this.addressItems.push(poolAddress);
                    if (!this.selectedAddress) {
                      this.selectedAddress = poolAddress;
                    }
                    LocalStorage.setPoolPubKey(poolAddress, pubkey);
                  }
                });
              }

            });
          }
        }
      });
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'reth', params: {source: 'validatorStatus'}});
    }
  }
}
</script>

<style lang="scss">
@import "../mixin.scss";

.eth-liquefy {
  background-color: #2B3239;
  width: 683px;
  height: 535px;
  border-radius: 19px;

  .liquefy-header {
    display: flex;
    margin-left: 63px;
    margin-bottom: 30px;

    .arrow-icon {
      cursor: pointer;
      margin-top: 40px;
      margin-right: 15px;
      height: 23px;
      img {
        height: 100%;
      }
    }
    
    .title {
      font-size: 30px;
      font-weight: bold;
      margin-top: 35px;
    }
  }

  .liquefy-content {

    margin-left: 91px;
    margin-right: 30px;

    .liquefy-desc {
      color: #C4C4C4;
      font-size: 16px;
      
    }

    .liquefy-item {
      .liquefy-item-title {
        margin-top: 23px;
        color: #7A7A7A;
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 6px;
      }

      .liquefy-item-input {
        select {
          border-radius: 3.65px;
          border: 1px solid #BFBFBF;
          padding: 16px 25px;
          background-color: #2B3239;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          outline: none;
          width: 469px;
        }

        input {
          border-radius: 3.65px;
          border: 1px solid #BFBFBF;
          padding: 16px 25px;
          background-color: #2B3239;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          width: 416px;

          &:focus {
            outline: none
          }
        }
      }
    }
  }


  .liquefy-btn {
    cursor: pointer;
    margin-left: 414px;
    width: 110px;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    color: #23292F;
    font-weight: bold;
    background-color: #00F3AB;
    border-radius: 21px;
    text-align: center;
    margin-top: 30px;
    opacity: 0.4;
  }

  .btn-active {
    opacity: 1;
  }

}
</style>
